<script setup lang="ts">
  import SkeletonQC from '@qicgroupdoha/qic-connect-ds/components/SkeletonQC'
  import FlowCard from './FlowCard.vue'
</script>

<template>
  <FlowCard :with-button="false" class="flow-card-skeleton">
    <div class="flow-card-skeleton__content">
      <SkeletonQC width="100%" height="24px" style="margin-bottom: var(--spacing-3)" />
      <SkeletonQC width="100%" height="24px" style="max-width: 240px; margin-bottom: 48px" />
      <SkeletonQC width="100%" height="60px" style="margin-bottom: var(--spacing-5)" />
      <SkeletonQC width="100%" height="60px" />
    </div>
  </FlowCard>
</template>

<style lang="scss" scoped>
  .flow-card-skeleton {
    min-height: 492px;

    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    @media (max-width: 550px) {
      min-height: 456px;
    }
  }
</style>
